import { Route, Navigate } from "react-router-dom";
const PrivateRoute = ({ children }) => {
  return true ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
